// @flow

import _ from "lodash";
import gql from "graphql-tag";

import type { OperationComponent, QueryProps } from "react-apollo";

import { graphql } from "react-apollo";

// FIXME: Adjust types and defaults below

export type UserProfile = {|
  age: number,
  country: string,
  education: string,
  occupation: string,
  satMath: ?number,
  arithmetic: number,
  sports: number,
  science: number,
  geography: number,
  fermiSkill: number,
  party: string,
  politicsKnowledgeUS: number,
  newspaperVolume: number
|};

export const userProfileDefaults = {
  age: 0,
  country: "United States",
  education: "High School",
  occupation: "",
  satMath: 0,
  arithmetic: 0,
  sports: 0,
  science: 0,
  geography: 0,
  fermiSkill: 0
};

// TODO: Next steps:
//

export const userProfileFields = _.keys(userProfileDefaults);

export const updateUserMutation = gql`
  mutation(
    $id: ID!
    $age: Int
    $country: String
    $education: String
    $occupation: String
    $satMath: Int
    $arithmetic: Int
    $sports: Int
    $science: Int
    $geography: Int
    $fermiSkill: Int
    $party: String
    $politicsKnowledgeUS: Int
    $newspaperVolume: Int
  ) {
    updateUser(
      id: $id
      age: $age
      country: $country
      education: $education
      occupation: $occupation
      satMath: $satMath
      arithmetic: $arithmetic
      sports: $sports
      science: $science
      geography: $geography
      fermiSkill: $fermiSkill
      party: $party
      politicsKnowledgeUS: $politicsKnowledgeUS
      newspaperVolume: $newspaperVolume
    ) {
      id
    }
  }
`;

export type updateUserMutationResult = {
  data: {
    updateUser: {
      id: string
    }
  }
}; // FIXME: & QueryProps equiv for mutation

export const createUserMutation = gql`
  mutation($email: String!, $password: String!) {
    createUser(
      authProvider: { email: { email: $email, password: $password } }
    ) {
      id
    }
  }
`;

export type createUserMutationResult = {
  data: {
    createUser: {
      id: string
    }
  }
}; // FIXME: & QueryProps equiv for mutation

export const signinUserMutation = gql`
  mutation($email: String!, $password: String!) {
    signinUser(email: $email, password: $password) {
      id
      token
    }
  }
`;

export type signinUserMutationResult = {
  data: {
    signinUser: {
      token: string
    }
  }
}; // FIXME: & QueryProps equiv for mutation

export const linkUserMutation = gql`
  mutation($secret: String!) {
    authWorker(secret: $secret) {
      id
      token
    }
  }
`;

export type linkUserMutationResult = {
  authData: {
    linkUser: {
      token: string,
      id: string
    }
  }
};

export const userQuery = gql`
  query {
    user {
      id
      email
      secret
    }
  }
`;

export type userQueryResult = {
  userData: {
    user?: {
      id: string,
      secret: ?string,
      email: ?string
    }
  } & QueryProps
};

export const userInfoQuery = gql`
  query {
    user {
      id
      age
      country
      education
      occupation
      satMath
      arithmetic
      sports
      science
      geography
      fermiSkill
    }
  }
`;

export type userInfoQueryResult = {
  profileData: UserProfile
};

export const withCreateUser = graphql(createUserMutation, {
  name: "createUser"
});

export const authUpdateMutation = gql`
  mutation($id: ID!, $email: String!, $password: String!) {
    updateAuth(id: $id, newEmail: $email, newPassword: $password) {
      id
    }
  }
`;

export type authUpdateMutationResult = {
  data: {
    authUpdate: {
      id: string
    }
  }
};

export const withAuthUpdate = graphql(authUpdateMutation, {
  name: "authUpdate"
});

export type authUpdateType = ({
  variables: { id: string, email: string, password: string }
}) => Promise<authUpdateMutationResult>;

export type updateUserType = ({ variables: UserProfile }) => Promise<
  updateUserMutationResult
>;

export type Credentials = { email: string, password: string };

export type createUserType = ({ variables: Credentials }) => Promise<
  createUserMutationResult
>;

export const withNetworkUser: OperationComponent<userQueryResult> = graphql(
  userQuery,
  {
    options: props => {
      return { fetchPolicy: "network-only" };
    },
    name: "userData"
  }
);

export const withUser = graphql(userQuery, { name: "userData" });

export const withNetworkUserInfo: OperationComponent<
  userInfoQueryResult
> = graphql(userInfoQuery, {
  options: props => {
    return { fetchPolicy: "network-only" };
  },
  name: "profileData"
});

export const withSigninUser = graphql(signinUserMutation, {
  name: "signinUser"
});

export const withLinkUser = graphql(linkUserMutation, {
  name: "linkUser"
});

export const withUpdateUser = graphql(updateUserMutation, {
  name: "updateUser"
});

export type signinUserType = ({ variables: Credentials }) => Promise<
  signinUserMutationResult
>;

export type UserType = {
  id: string,
  secret: string,
  email?: string
};

// Check if the value for the required field 'age' exists
export const profileExists = (userProfile?: UserProfile) => {
  if (!userProfile) {
    return false;
  }

  return Boolean(userProfile.age);
};



// WEBPACK FOOTER //
// ./src/data/accounts.js